export default __webpack_public_path__ + "static/media/person_2@2x.5b9977f2.png";